import React from "react";
import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import AppSidebar from "./AppSidebar";
import { useHybridResponsive } from "../hooks";

const { Content } = Layout;

/**
 * AppLayout – wraps all authenticated pages with the sidebar on desktop.
 * On mobile the sidebar is hidden; the NavigationBar handles mobile navigation.
 */
const AppLayout: React.FC = () => {
  const { isMobile } = useHybridResponsive();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {!isMobile && <AppSidebar />}
      <Layout style={{ minHeight: "100vh" }}>
        <Content style={{ display: "flex", flexDirection: "column" }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
